import toggleReportActionComposeView from '../toggleReportActionComposeView';

export default (isSmallScreenWidth = true) => {
    toggleReportActionComposeView(true, isSmallScreenWidth);
};
